<template>
  <div id="contacts">
    <h2>Kontakty</h2>
    <div class="contacts-container">
      <div class="info_data">
        <h3>Adresa firmy:</h3>
        <p>Pavel Kolarovič</p>
        <p>Habartice 194</p>
        <p>IČ: 68970978</p>
        <p>Fyzická osoba zapsaná v Živnostenském rejstříku od 1. dubna 2000</p>
      </div>
      <div class="contacts">
        <h3>Kontaktní údaje:</h3>
        <p>PRODEJ AUT - Pavel KOLAROVIČ</p>
        <p>
          <font-awesome-icon icon="phone-alt" title="Telefon" />
          <span>+420 602 971 548</span>
        </p>
        <p>AUTOSERVIS - Michal BUREŠ</p>
        <p>
          <font-awesome-icon icon="phone-alt" title="Telefon" />
          <span>+420 774 560 510</span>
        </p>
        <p>Email</p>
        <p>
          <font-awesome-icon icon="envelope" title="Telefon" />
          <span>info@autokolarovic.cz</span>
        </p>
        <p>Email</p>
        <p style="display: flex; align-items: center;">
          <i class="material-icons facebook">facebook</i>
          <a href="https://www.facebook.com/autokolarovic/" style="margin-left: 0.5rem;" target="_blank">
           
            https://www.facebook.com/autokolarovic/
          </a>
        </p>
       
      </div>
    </div>
    <div class="mapouter">
      <div class="gmap_canvas">
        <iframe
          width="100%"
          height="395"
          id="gmap_canvas"
          src="https://maps.google.com/maps?q=Habartice%20194&t=&z=17&ie=UTF8&iwloc=&output=embed"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";

#contacts {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 50;
  background-color: rgb(185, 185, 185);
  h2 {
    padding-bottom: 1rem;
  }
  .contacts-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.5rem;
    padding-bottom: 2rem;
    font-size: 0.8rem;
    p {
      margin: 0;
      padding: 0.5rem;
    }
    .info_data {
      display: flex;
      flex-direction: column;
      text-align: left;
      margin: 0;
      @media (min-width: $min-width-extended) {
        margin: 0 5rem;
      }
    }
    .contacts {
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      text-align: left;
      @media (min-width: $min-width-extended) {
        margin: 0 5rem;
      }
      p {
        span {
          padding-left: 0.5rem;
        }
      }
    }
  }

  .mapouter {
    position: relative;
    text-align: right;
    height: 395px;
    width: 100%;
  }
  .gmap_canvas {
    overflow: hidden;
    background: none;
    height: 395px;
    width: 100%;
  }
  @media (min-width: $min-width-extended) {
    .contacts-container {
      padding: 0;
      padding-bottom: 2rem;
      font-size: 1rem;
    }
  }
}
</style>
